module.exports = __webpack_public_path__ + "img/alipay.de192b8b.png";